import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=d1ee12d0"
import script from "./OrderList.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports